export default "__VITE_ASSET__482b1d2d__"